import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Upload } from "lucide-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVehicle } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function createData(
  id,
  attachments,
  tyrePosition,
  tyreDotNo,
  tyreSize,
  tyreType,
  tyrePrice,
  kilometerLimit,
  manufacturedBy,
  purchaseDate,
  isActive,
  warrantyPeriod,
  warrantyStartDate,
  warrantyEndDate,
  isInstalled,
  dateOfInstallation,
  isSwapped,
  swappedFromVehicleId,
  vendorName,
  vendorContact,
  vendorAddress,
  isPaymentPending,
  costToCompany,
  totalCost,
  createdAt,
  rawData,
) {
  return {
    id,
    attachments,
    tyrePosition,
    tyreDotNo,
    tyreSize,
    tyreType,
    tyrePrice,
    kilometerLimit,
    manufacturedBy,
    purchaseDate,
    isActive,
    warrantyPeriod,
    warrantyStartDate,
    warrantyEndDate,
    isInstalled,
    dateOfInstallation,
    isSwapped,
    swappedFromVehicleId,
    vendorName,
    vendorContact,
    vendorAddress,
    isPaymentPending,
    costToCompany,
    totalCost,
    createdAt,
    rawData,
  };
}

const Mytyres = ({ selectedRow }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.issuePriority;
  const tyrePosition = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.tyrePosition;
  delete tyrePosition?.inverted;
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [vehicleFilterListings, setVehicleFilterListings] = useState([]);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [uploadedImages, setUploadedImages] = useState(null);
  const [errors, setErrors] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [tyreDetails, setTyreDetails] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editTyreId, setTyreId] = useState(null);
  const [open, setOpen] = useState(false);

  const handleImageOpen = (img) => {
    setPreviewImage(img);
    setPreviewOpen(true);
  };

  const generalInformationofTyre = [
    {
      label: "Tyre Position",
      value: "tyrePosition",
      type: "dropdown",
      disabled: false,
      subCategory:
        tyrePosition &&
        Object.entries(tyrePosition).map(([key, value]) => ({
          value: value, // or whatever property you want
          label: key,
        })),
    },
    {
      label: "Tyre DOT No",
      value: "tyreDotNo",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Tyre Size",
      value: "tyreSize",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Tyre Type",
      value: "tyreType",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "Tubeless", value: "Tubeless" },
        { key: "Tube", value: "Tube" },
      ],
    },
    {
      label: "Tyre Price",
      value: "tyrePrice",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Kilometer Limit",
      value: "kilometerLimit",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Date of Manufacturing",
      value: "dateOfManufacturing",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Manufactured By",
      value: "manufacuturedBy",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Period",
      value: "warrantyPeriod",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Purchase Date",
      value: "purchaseDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty Start Date",
      value: "startDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Warranty End Date",
      value: "endDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Installed Date",
      value: "installedDate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Is Installed",
      value: "isInstalled",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Is Swapped",
      value: "isSwapped",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Swapped Old Vehicle no",
      value: "vehicleNo",
      type: "dropdown",
      disabled: false,
      subCategory:
        vehicles &&
        Object.entries(vehicles).map(([key, item]) => ({
          value: item?.licensePlate + "__" + item?.name, // or whatever property you want
          label: item?.id,
        })),
    },
    {
      label: "Issue Id",
      value: "issueId",
      type: "dropdown",
      disabled: false,
      subCategory:
        myIssues &&
        Object.entries(myIssues).map(([key, item]) => ({
          value: item?.code, // or whatever property you want
          label: item?.id,
        })),
    },
    {
      label: "Vendor Name",
      value: "vendorName",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vendor Contact",
      value: "vendorContact",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vendor Address",
      value: "vendorAddress",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Is Payment Pending",
      value: "isPaymentPending",
      type: "dropdown",
      disabled: false,
      subCategory: [
        { key: "true", value: "True" },
        { key: "false", value: "False" },
      ],
    },
    {
      label: "Cost to Company",
      value: "costToCompany",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Attachments",
      value: "attachments",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const formatDateToInput = (dateString) => {
    if (!dateString) return "";

    if (dateString.includes("T")) {
      return dateString.split("T")[0];
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    }

    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const parts = dateString.split(" ");
    const dateParts = parts[0].split("-");

    if (dateParts.length === 3) {
      const day = dateParts[0].padStart(2, "0");
      const month = months[dateParts[1]?.toLowerCase()] || dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleEdit = (row) => {
    setHideTestFields(true);
    setIsEdit(true);
    setTyreId(row.id);

    const rawTyreDetails = tyreDetails.find((b) => b.id === row.id);

    let parsedAttachments = [];
    try {
      const attachmentsData = row?.attachments || rawTyreDetails?.attachments;
      if (typeof attachmentsData === "string") {
        parsedAttachments = JSON.parse(attachmentsData);
      } else if (Array.isArray(attachmentsData)) {
        parsedAttachments = attachmentsData;
      }
    } catch (e) {
      parsedAttachments = [];
    }

    setForm({
      tyrePosition: row?.tyrePosition || rawTyreDetails?.tyrePosition || "",
      tyreDotNo: row?.tyreDotNo || rawTyreDetails?.tyreDotNo || "",
      tyreSize: row?.tyreSize || rawTyreDetails?.tyreSize || "",
      tyreType: row?.tyreType || rawTyreDetails?.tyreType || "",
      tyrePrice: row?.tyrePrice || rawTyreDetails?.tyrePrice || "",
      kilometerLimit:
        row?.kilometerLimit || rawTyreDetails?.kilometerLimit || "",
      dateOfManufacturing: formatDateToInput(
        rawTyreDetails?.dateOfInstallation || row?.dateOfInstallation || "",
      ),
      manufacuturedBy:
        row?.manufacturedBy || rawTyreDetails?.manufacturedBy || "",
      warrantyPeriod:
        row?.warrantyPeriod || rawTyreDetails?.warrantyPeriod || "",
      purchaseDate: formatDateToInput(rawTyreDetails?.purchaseDate || ""),

      startDate: formatDateToInput(
        rawTyreDetails?.warrantyStartDate || row?.warrantyStartDate || "",
      ),

      endDate: formatDateToInput(
        rawTyreDetails?.warrantyEndDate || row?.warrantyEndDate || "",
      ),

      installedDate: formatDateToInput(
        rawTyreDetails?.dateOfInstallation || row?.dateOfInstallation || "",
      ),
      isInstalled: row?.isInstalled ? "true" : "false",
      isSwapped: row?.isSwapped ? "true" : "false",
      vehicleNo:
        row?.swappedFromVehicleId ||
        rawTyreDetails?.swappedFromVehicleId ||
        null,
      issueId: row?.issueId || null,
      vendorName: row?.vendorName || rawTyreDetails?.vendorName || null,
      vendorContact:
        row?.vendorContact || rawTyreDetails?.vendorContact || null,
      vendorAddress:
        row?.vendorAddress || rawTyreDetails?.vendorAddress || null,
      attachments: parsedAttachments,
    });

    // Set uploaded images for preview
    if (row?.attachments) {
      try {
        const attachments =
          typeof row.attachments === "string"
            ? JSON.parse(row.attachments)
            : row.attachments;
        setUploadedImages(attachments);
      } catch (e) {
        setUploadedImages(row?.attachments || null);
      }
    }

    // Scroll to the form section
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const rows =
    (tyreDetails &&
      tyreDetails.map((item) =>
        createData(
          item?.id,
          item?.attachments,
          item?.tyrePosition,
          item?.tyreDotNo,
          item?.tyreSize,
          item?.tyreType,
          item?.tyrePrice,
          item?.kilometerLimit,
          item?.manufacturedBy,
          formatDateAndTime(item?.purchaseDate) || "-",
          item?.isActive,
          item?.warrantyPeriod,
          formatDateAndTime(item?.startDate),
          formatDateAndTime(item?.endDate),
          item?.isInstalled,
          formatDateAndTime(item?.dateOfInstallation),
          item?.isSwapped,
          item?.swappedFromVehicleId,
          item?.vendorName,
          item?.vendorContact,
          item?.vendorAddress,
          item?.isPaymentPending,
          item?.costToCompany,
          item?.totalCost,
          formatDateAndTime(item?.createdAt),
          item,
        ),
      )) ||
    [];

  const getTyreDetails = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicletyredetails?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setTyreDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleIssues = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVehicleAPI = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles?limit=${1000}&offset=${0}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setVehicles(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    }
  };

  useEffect(() => {
    if (selectedRow) {
      getTyreDetails(
        selectedRow.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleIssues(
        selectedRow.id,
        paginationModel.page,
        paginationModel.pageSize,
      );
      getVehicleAPI();
    }
  }, [selectedRow, paginationModel]);

  const handleChange = async (field, value) => {
    if (field === "attachments") {
      await uploadmutiplefile(value, "vehicles", "vehicle").then((res) => {
        let filterImages = res?.uploaded?.map((image) => image?.url);
        setUploadedImages((prev) => {
          if (!prev || prev.length === 0) {
            return filterImages; // first upload
          }
          return [...prev, ...filterImages]; // append
        });
        setForm((prev) => ({
          ...prev,
          [field]: res?.uploaded || "",
        }));
      });
    } else {
      setForm((prev) => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    // Battery ID
    if (!form.tyrePosition) {
      newErrors.tyrePosition = "Tyre Position is required";
    }

    if (!form.tyreDotNo) {
      newErrors.tyreDotNo = "Tyre DOT no is required";
    }

    if (!form.tyreSize) {
      newErrors.tyreSize = "Tyre Size is required";
    }

    if (!form.tyreType) {
      newErrors.tyreType = "Tyre Type is required";
    }

    if (!form.tyrePrice) {
      newErrors.tyrePrice = "Tyre Price is required";
    }

    if (!form.purchaseDate) {
      newErrors.purchaseDate = "Purchase Date is required";
    }

    // Date of Manufacturing
    if (!form.dateOfManufacturing) {
      newErrors.dateOfManufacturing = "Manufacturing date is required";
    } else if (new Date(form.dateOfManufacturing) > new Date()) {
      newErrors.dateOfManufacturing = "Manufacturing date cannot be future";
    }

    // Manufactured By
    if (!form.manufacuturedBy?.trim()) {
      newErrors.manufacuturedBy = "Manufacturer name is required";
    }

    // Warranty
    if (!form.warrantyPeriod) {
      newErrors.warrantyPeriod = "Warranty period is required";
    } else if (Number(form.warrantyPeriod) <= 0) {
      newErrors.warrantyPeriod = "Warranty must be greater than 0";
    }

    // Start Date
    if (!form.startDate) {
      newErrors.startDate = "Start date is required";
    } else if (
      form.dateOfManufacturing &&
      new Date(form.startDate) < new Date(form.dateOfManufacturing)
    ) {
      newErrors.startDate = "Start date must be after manufacturing date";
    }

    // End Date
    if (!form.endDate) {
      newErrors.endDate = "End date is required";
    } else if (
      form.startDate &&
      new Date(form.endDate) < new Date(form.startDate)
    ) {
      newErrors.endDate = "End date must be after start date";
    }

    // Is Installed
    if (form.isInstalled === undefined) {
      newErrors.isInstalled = "Please select installation status";
    }

    // Installed Date (only if installed)
    if (form.isInstalled === "true" && !form.installedDate) {
      newErrors.installedDate = "Installed date is required";
    }

    // Is Swapped
    if (form.isSwapped === undefined) {
      newErrors.isSwapped = "Please select swap status";
    }

    // if (!form.vendorAddress) {
    //   newErrors.vendorAddress = "Please add Vendor Address";
    // }

    // if (!form.vendorContact) {
    //   newErrors.vendorContact = "Please add Vendor Contact";
    // }

    // if (!form.vendorName) {
    //   newErrors.vendorName = "Please add Vendor Name";
    // }

    // Attachments
    if (!form.attachments || form.attachments.length === 0) {
      newErrors.attachments = "At least one attachment is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddNewBattery = async () => {
    let payload = {};
    if (editTyreId) {
      payload = {
        id: editTyreId,
        tyrePosition: form?.tyrePosition,
        tyreDotNo: form?.tyreDotNo,
        tyreSize: form?.tyreSize,
        tyreType: form?.tyreType,
        tyrePrice: form?.tyrePrice,
        kilometerLimit: form?.kilometerLimit,
        dateOfManufacturing: form?.dateOfManufacturing,
        manufacturedBy: form?.manufacuturedBy,
        purchaseDate: form?.purchaseDate,
        vehicleId: selectedRow?.id,
        // isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        startDate: form?.startDate,
        endDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        dateOfInstallation: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        issueCode: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
      };
    } else {
      payload = {
        tyrePosition: form?.tyrePosition,
        tyreDotNo: form?.tyreDotNo,
        tyreSize: form?.tyreSize,
        tyreType: form?.tyreType,
        tyrePrice: form?.tyrePrice,
        kilometerLimit: form?.kilometerLimit,
        manufacturedBy: form?.manufacuturedBy,
        dateOfManufacturing: form?.dateOfManufacturing,
        purchaseDate: form?.purchaseDate,
        vehicleId: selectedRow?.id,
        // isActive: "true",
        warrantyPeriod: form?.warrantyPeriod,
        startDate: form?.startDate,
        endDate: form?.endDate,
        isInstalled: form?.isInstalled === "true" ? 1 : 0,
        dateOfInstallation: form?.installedDate,
        isSwapped: form?.isSwapped,
        swappedFromVehicleId: form?.vehicleNo,
        issueId: form?.issueId,
        issueCode: form?.issueId,
        attachments: JSON.stringify(form?.attachments),
        vendorName: form?.vendorName,
        vendorContact: form?.vendorContact,
        vendorAddress: form?.vendorAddress,
        isPaymentPending: form?.isPaymentPending === "true" ? 1 : 0,
        costToCompany: Number(form?.costToCompany),
      };
    }
    try {
      const response = await fetch(`${apiUrl}/api/vehicletyredetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({});
        setUploadedImages(null);
        toast.success("New Battery Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setErrors({});
        setTyreId(null);
        setIsEdit(false);
        getTyreDetails(
          selectedRow.id,
          paginationModel.page,
          paginationModel.pageSize,
        );
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Tyre Details</h1>{" "}
        {hideTextfields ? (
          <CloseIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(false);
            }}
          />
        ) : (
          <AddCircleOutlineIcon
            className="cursor-pointer"
            onClick={() => {
              setHideTestFields(true);
            }}
          />
        )}
      </div>
      {hideTextfields && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 p-6 rounded-lg">
            {generalInformationofTyre.map((field, index) => (
              <div key={index} className="group">
                <label className="block mb-2 font-semibold text-gray-700 text-sm">
                  {field.label}
                  {field.required && (
                    <span className="text-red-500 ml-1">*</span>
                  )}
                </label>

                {/* DROPDOWN */}
                {field.type === "dropdown" && (
                  <FormControl fullWidth size="small">
                    <InputLabel id={`select-label-${index}`}>
                      {field.label}
                    </InputLabel>

                    <Select
                      labelId={`select-label-${index}`}
                      value={form[field.value] || ""}
                      label={field.label}
                      disabled={field.disabled}
                      onChange={(e) =>
                        handleChange(field.value, e.target.value)
                      }
                      sx={{
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e7eb",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6366f1",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#4f46e5",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            borderRadius: "8px",
                          },
                        },
                      }}
                    >
                      {field?.subCategory
                        ?.filter((opt) => opt.item !== "inverted")
                        .map((option, idx) => (
                          <MenuItem
                            key={idx}
                            value={option.key ?? option.label ?? option.value}
                          >
                            {option.value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                {/* FILE UPLOAD */}
                {field.type === "file" && (
                  <div className="space-y-2">
                    <Button
                      component="label"
                      variant="outlined"
                      fullWidth
                      disabled={field.disabled}
                      startIcon={<Upload size={18} />}
                      sx={{
                        borderStyle: "dashed",
                        borderRadius: "8px",
                        padding: "12px",
                        color: "#4f46e5",
                        borderColor: "#a5b4fc",
                        "&:hover": {
                          borderColor: "#6366f1",
                          backgroundColor: "#eef2ff",
                        },
                      }}
                    >
                      {form[field.value]?.length
                        ? "Change Files"
                        : "Upload Files"}
                      <input
                        hidden
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) =>
                          handleChange(field.value, e.target.files)
                        }
                      />
                    </Button>
                  </div>
                )}

                {/* TEXT / NUMBER / DATE */}
                {field.type !== "dropdown" && field.type !== "file" && (
                  <TextField
                    fullWidth
                    size="small"
                    type={field.type}
                    value={form[field.value] || ""}
                    disabled={field.disabled}
                    onChange={(e) => handleChange(field.value, e.target.value)}
                    placeholder={`Enter ${field.label.toLowerCase()}`}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: field.disabled ? "#f3f4f6" : "#fff",
                      },
                    }}
                  />
                )}
              </div>
            ))}
          </div>
          {uploadedImages && (
            <div className="grid grid-cols-1 bg-white p-4 rounded-lg">
              {uploadedImages?.length > 0 ? (
                <div className="mt-6 flex gap-4 flex-wrap">
                  {uploadedImages.map((image, index) => (
                    <img
                      key={index}
                      src={
                        image?.url || image?.Location || image?.path || image
                      }
                      alt="Image Preview"
                      className="w-28 h-28 rounded-lg object-cover border shadow"
                    />
                  ))}
                </div>
              ) : (
                <div className="mt-6 flex gap-4 flex-wrap">
                  <img
                    src={uploadedImages}
                    alt="Image Preview"
                    className="w-44 h-44 rounded-lg object-cover border shadow"
                  />
                </div>
              )}
            </div>
          )}
          <div className="flex justify-end p-6">
            {Object.keys(errors).length > 0 && (
              <div className="text-red-600 text-sm mb-4">
                <ul className="list-disc pl-5">
                  {Object.values(errors).map((err, index) => (
                    <li key={index}>{err}</li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={() => {
                if (!validateForm()) return;
                handleAddNewBattery();
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700
  text-white font-semibold px-5 py-2.5 rounded-lg shadow-md"
            >
              {isEdit ? "Update" : "+ Add"}
            </button>
          </div>{" "}
        </>
      )}

      <div className="p-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Attachments</TableCell>
              <TableCell>Tyre Position</TableCell>
              <TableCell>Tyre Dot No</TableCell>
              <TableCell>Tyre Size</TableCell>
              <TableCell>Tyre Type</TableCell>
              <TableCell>Tyre Price</TableCell>
              <TableCell>Kilometer Limit</TableCell>
              <TableCell>Is Installed</TableCell>
              <TableCell>Warranty Period</TableCell>
              <TableCell>Is Swapped</TableCell>

              {/* MAIN COST COLUMNS */}
              <TableCell>Cost To Company</TableCell>
              <TableCell>Total Cost</TableCell>

              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length ? (
              rows.map((r, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell>{r.id}</TableCell>

                    {/* ATTACHMENTS / EXPAND */}
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => setOpen(open === index ? -1 : index)}
                      >
                        {open === index ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    </TableCell>

                    <TableCell>{tyrePosition[r.tyrePosition] || "-"}</TableCell>

                    <TableCell>{r.tyreDotNo || "-"}</TableCell>

                    <TableCell>{r.tyreSize || "-"}</TableCell>

                    <TableCell>{r.tyreType || "-"}</TableCell>

                    <TableCell>{r.tyrePrice || "-"}</TableCell>

                    <TableCell>{r.kilometerLimit || "-"}</TableCell>

                    {/* IS INSTALLED */}
                    <TableCell
                      style={{
                        backgroundColor: r.isInstalled
                          ? "lightgreen"
                          : "lightcoral",
                        color: "black",
                      }}
                    >
                      {r.isInstalled ? "Yes" : "No"}
                    </TableCell>

                    <TableCell>{r.warrantyPeriod || "-"}</TableCell>

                    {/* IS SWAPPED */}
                    <TableCell
                      style={{
                        backgroundColor: r.isSwapped
                          ? "lightgreen"
                          : "lightcoral",
                        color: "black",
                      }}
                    >
                      {r.isSwapped ? "Yes" : "No"}
                    </TableCell>

                    {/* COST TO COMPANY */}
                    <TableCell sx={{ fontWeight: "bold" }}>
                      {r.costToCompany !== null &&
                      r.costToCompany !== undefined &&
                      r.costToCompany !== ""
                        ? `₹ ${Number(r.costToCompany).toLocaleString("en-IN")}`
                        : "-"}
                    </TableCell>

                    {/* TOTAL COST */}
                    <TableCell sx={{ fontWeight: "bold" }}>
                      {r.totalCost !== null &&
                      r.totalCost !== undefined &&
                      r.totalCost !== ""
                        ? `₹ ${Number(r.totalCost).toLocaleString("en-IN")}`
                        : "-"}
                    </TableCell>

                    {r?.rawData?.serviceLogId &&
                    r?.rawData?.serviceLogId !== 0 ? (
                      <TableCell>
                        <Button
                          onClick={() => {
                            const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                            window.open(navigate, "_blank");
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                    ) : null}
                  </TableRow>

                  {/* EXPANDED DETAILS */}
                  <TableRow>
                    <TableCell colSpan={14} sx={{ p: 0 }}>
                      <Collapse in={open === index}>
                        <Box sx={{ p: 2 }}>
                          <h1>
                            <b>Vendor Name:</b> {r.vendorName || "-"}
                          </h1>

                          <h1>
                            <b>Vendor Contact:</b> {r.vendorContact || "-"}
                          </h1>

                          <h1>
                            <b>Vendor Address:</b> {r.vendorAddress || "-"}
                          </h1>

                          <h1>
                            <b>Is Payment Pending:</b>{" "}
                            {r.isPaymentPending ? "Yes" : "No"}
                          </h1>

                          <h1>
                            <b>Purchase Date:</b> {r.purchaseDate || "-"}
                          </h1>

                          <h1>
                            <b>Installed Date:</b> {r.dateOfInstallation || "-"}
                          </h1>

                          <h1>
                            <b>Manufacturer Name:</b> {r.manufacturedBy || "-"}
                          </h1>

                          <h1>
                            <b>Warranty Start:</b> {r.warrantyStartDate || "-"}
                          </h1>

                          <h1>
                            <b>Warranty End:</b> {r.warrantyEndDate || "-"}
                          </h1>

                          {/* ATTACHMENTS */}
                          <Box
                            sx={{
                              m: 2,
                              display: "flex",
                              gap: 2,
                              flexWrap: "wrap",
                            }}
                          >
                            {r.attachments?.length > 0 ? (
                              JSON.parse(r.attachments).map((file, i) => {
                                const imageUrl =
                                  file?.url ||
                                  file?.Location ||
                                  file?.image ||
                                  file?.path;

                                return (
                                  <div key={i}>
                                    <img
                                      src={imageUrl}
                                      alt={`Attachment ${i + 1}`}
                                      onClick={() => handleImageOpen(imageUrl)}
                                      className="w-44 h-44 cursor-pointer rounded-lg hover:opacity-80"
                                    />
                                  </div>
                                );
                              })
                            ) : (
                              <Typography sx={{ color: "red" }} variant="body2">
                                No Attachments
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={14}
                  align="center"
                  sx={{ fontWeight: "bold", py: 3 }}
                >
                  No Tyre Details Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
      {previewOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={() => setPreviewOpen(false)}
        >
          <img
            src={previewImage}
            className="max-h-[90%] max-w-[90%] rounded-lg shadow-lg"
          />
        </div>
      )}
    </>
  );
};

export default Mytyres;
